import { useEffect, useState } from 'react';

export interface IOembedResponse {
  title: string;
  thumbnail_url: string;
}

export function useOembed(url: string | undefined) {
  const [oembed, setOembed] = useState<IOembedResponse | null>(null);

  useEffect(() => {
    if (!url) return;

    fetch(`https://www.youtube.com/oembed?url=${url}&format=json`)
      .then((response) => response.json())
      .then((data) => setOembed(data));
  }, [url]);

  return oembed;
}
